// The people a task can belong to. Add a name here to make it selectable on the board.
export const TEAM = [
  { name: 'Christian', color: '#006cfd' },
  { name: 'Alex', color: '#059669' },
];

/** A task the whole team shares. */
export const EVERYONE = 'Alle';

export const memberColor = (name) => TEAM.find((m) => m.name === name)?.color || '#6b7280';
